jQuery(document).ready(function ($) {
    // The small size is a centred, swipeable strip on mobile and a plain row from tablet up. Swiper only exists
    // on mobile: disabling it would leave its transform behind, so it's destroyed (and its styles cleaned) otherwise.
    const mobile = window.matchMedia('(max-width: 48em)');

    $('.team-members__carousel.swiper').each(function () {
        const $carousel = $(this);
        const count = $carousel.find('.swiper-slide').length;

        let swiper = null;

        const update = function () {
            if (mobile.matches && !swiper) {
                swiper = new Swiper(`#${$carousel.attr('id')}`, {
                    slidesPerView: 'auto',

                    centeredSlides: true,

                    // Keep centring the active member even when every slide would fit on screen
                    watchOverflow: false,

                    // With a few members, start on the middle one so both neighbours show
                    initialSlide: count <= 3 ? Math.floor((count - 1) / 2) : 0,

                    spaceBetween: 16,

                    grabCursor: true
                });
            } else if (!mobile.matches && swiper) {
                swiper.destroy(true, true);

                swiper = null;
            }
        };

        mobile.addEventListener('change', update);

        update();
    });
});
